/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: NativeCollabProviderQuery
// ====================================================

export interface NativeCollabProviderQuery_user_photos {
  value: string | null;
  isPrimary: boolean | null;
}

export interface NativeCollabProviderQuery_user_confluence {
  permissionType: SitePermissionType | null;
}

export interface NativeCollabProviderQuery_user {
  id: string | null;
  displayName: string | null;
  photos: (NativeCollabProviderQuery_user_photos | null)[] | null;
  confluence: NativeCollabProviderQuery_user_confluence | null;
}

export interface NativeCollabProviderQuery {
  user: NativeCollabProviderQuery_user | null;
}

export interface NativeCollabProviderQueryVariables {
  accountId?: string | null;
  shouldIncludePermissionType?: boolean | null;
}
